import React from 'react'
import { FormattedMessage } from 'react-intl'
import { fade, withStyles, Menu, IconButton, MenuItem } from '@material-ui/core'
import { useStyles } from './Styles'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import SendIcon from '@material-ui/icons/Send'
import EditIcon from '@material-ui/icons/Edit'

const DraftsActionsMenu = ({ selectedRow, id, sign, openDialog, locale, isTemplate }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isMenuView, setIsMenuView] = React.useState(false)
  const isMenuOpen = Boolean(anchorEl)
  const menuId = 'header-account-menu'
  const StyledMenu = withStyles((theme) => ({
    paper: {
      borderRadius: theme.spacing(0),
      boxShadow: `0 8px 16px -4px ${fade(theme.palette.common.white, 0.16)}`,
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0),
      textAlign: 'left',
      '& .MuiMenu-list': {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // width: 220,
        border: `1px solid ${theme.palette.colors.border}`
      }
    }
  }))((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      {...props}
    />
  ))

  const handleProfileMenuOpen = (event) => {
    setIsMenuView(true)
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
    setTimeout(() => setIsMenuView(false), 300)
  }

  let userActions = !!isTemplate ? [
    {
      name: 'edit',
      icon: <EditIcon/>
    },
    {
      name: 'delete',
      icon: <DeleteForeverOutlinedIcon/>
    }
  ] : [
    {
      name: !!sign ? 'sign' : 'submit',
      icon: <SendIcon/>
    },
    {
      name: 'delete',
      icon: <DeleteForeverOutlinedIcon/>
    }
  ]
  return (
    <>
      <IconButton
        aria-label={<FormattedMessage id='ActionsMenu.label'/>}
        aria-controls={menuId}
        aria-haspopup="true"
        className={classes.actionMenuButton}
        onClick={handleProfileMenuOpen}
        color="inherit"
      >
        <MoreVertIcon color='primary'/>
      </IconButton>
      {!!isMenuView &&
      <StyledMenu
        id={menuId}
        anchorEl={anchorEl}
        keepMounted
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {!!userActions && !!userActions.length && userActions.map((actionData, index) => (
          <MenuItem
            disabled={false}
            key={index}
            onClick={() => openDialog(actionData.name, selectedRow, id, handleMenuClose)}
            className={classes.buttonAction + ` ${actionData.name}`}>
            {actionData.icon}
            <FormattedMessage id={`DraftsActionsMenu.button.${actionData.name}`}
                              values={{
                                strong: chunks => <strong>{chunks}</strong>
                              }}/>
          </MenuItem>
        ))}
      </StyledMenu>
      }
    </>
  )
}

export default DraftsActionsMenu
